import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';

export const Layout = () => import('@/layout/index.vue');

// 静态路由
export const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/view/login/index.vue'),
    meta: { fullScreen: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Home',
        component: () => import('@/view/home/index.vue'),
        meta: { title: '数据看板', en: 'DASHBOARD · OVERVIEW', icon: 'DataBoard' }
      },
      {
        path: '/data_status',
        name: 'DataStatus',
        component: () => import('@/view/data_status/index.vue'),
        meta: { title: '数据统计', en: 'ANALYTICS · INSIGHTS', icon: 'TrendCharts' }
      },
      {
        path: '/orders',
        name: 'Orders',
        component: () => import('@/view/orders/index.vue'),
        meta: { title: '订单管理', en: 'ORDERS', icon: 'ShoppingCart' }
      },
      {
        path: '/stores',
        name: 'Stores',
        component: () => import('@/view/stores/index.vue'),
        meta: { title: '影楼管理', en: 'STUDIO MANAGEMENT', icon: 'Shop' }
      },
      {
        path: '/factory_management',
        name: 'FactoryManagement',
        component: () => import('@/view/factory_management/index.vue'),
        meta: { title: '工厂管理', en: 'FACTORY MANAGEMENT', icon: 'OfficeBuilding' }
      },
      {
        path: '/studio_billing',
        name: 'StudioBilling',
        component: () => import('@/view/studio_billing/index.vue'),
        meta: { title: '影楼模块价格', en: 'STUDIO MODULE PRICING', icon: 'Tickets' }
      },
      {
        path: '/factory_billing',
        name: 'FactoryBilling',
        redirect: '/factory_management'
      },
      {
        path: '/data_setting',
        name: 'DataSetting',
        component: () => import('@/view/data_setting/index.vue'),
        meta: { title: '拍照类型', en: 'PHOTO TYPES', icon: 'Camera' }
      },
      {
        path: '/system_setting',
        name: 'SystemSetting',
        component: () => import('@/view/system_setting/index.vue'),
        meta: { title: '系统设置', en: 'SYSTEM · SETTINGS', icon: 'Setting' }
      }
    ]
  }
];

/**
 * 创建路由
 */
const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes as RouteRecordRaw[],
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 })
});

// 回登录页
export function goLogin() {
  router.push('/login');
}

export default router;
